import React, { useEffect, useState } from "react";
import { MdOutlineEnergySavingsLeaf } from "react-icons/md";
import { FaHandHoldingWater } from "react-icons/fa";
import { TbVaccineBottleOff } from "react-icons/tb";
import { IoFastFood } from "react-icons/io5";
import { FaBox } from "react-icons/fa6";
import { IoMan } from "react-icons/io5";
import { FaBoxesPacking } from "react-icons/fa6";
import { FaCircle } from "react-icons/fa";
import { Line, Pie } from "react-chartjs-2";
import axiosConn from "config/axiosConn.js";
import { MdEventNote } from "react-icons/md";
import { jwtDecode } from 'jwt-decode';
import { Card, CardHeader, CardBody, CardFooter, CardTitle, Row, Col } from "reactstrap";
import Langfield from "../../assets/Json/dashboardJson.json";
import FacultySideBar from "./FacultySideBar";
import Helper from "../../helper/Common_Helper"
import { Link } from 'react-router-dom'
import { GrRestroomWomen } from "react-icons/gr";
import { changeLang, selectedVoice } from '../../redux/langSlice'
import { useDispatch } from 'react-redux'
import { FaBarsStaggered } from "react-icons/fa6";
import { useSelector } from "react-redux";

function AdminDashboard() {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [langSelected, setLangSelected] = useState('en-IN');
  const translations = Langfield[langSelected];
  const [storeLang, setStoreLang] = useState('en-IN');
  // const [storeLang, setStoreLang] = useState('en-IN');
  const [countData, setCountData] = useState({})
  const [role, setRole] = useState();
  const [schoolName, setSchoolName] = useState('');
  const [udise_id, setUDISE] = useState('');
  const [teacher_name, setTeacherName] = useState('');
  const [matrixCount, setMatrixCount] = useState({});
  const dispatch = useDispatch();
  const userData = useSelector(state => state.auth.user);
  console.log(userData, "userDataFACULTY");

  const translate = (key) => {
    // Check if translations is defined and is an object
    if (typeof translations !== 'object' || translations === null) {
      return key; // Return the key if translations is not available
    }

    // Handle undefined or non-string keys
    if (typeof key !== 'string') {
      return key; // Return the value as is if key is not a string
    }

    return translations[key] || key.replace(/_/g, ' '); // Use translation or fallback to the key
  };
  ;

  const [lineChartData, setLineChartData] = useState({
    labels: [translate("January"), translate("February"), translate("March"), translate("April"), translate("May"), translate("June"), translate("July"), translate("August"), translate("September"), translate("October"), translate("November"), translate("December")],
    datasets: [
      {
        label: translate("Digital"),
        borderColor: "#4caf50",
        fill: false,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        label: translate("Physical"),
        borderColor: "#f44336",
        fill: false,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  useEffect(() => {
    getCount();
    // let token = localStorage.getItem('token');
    if (userData) {
      setRole(userData.role);
      setUDISE(userData.udise_id);
      getMatricData(userData.udise_id);
      setSchoolName(userData.school_name);
      setLangSelected(userData?.lang)
      setStoreLang(userData.lang)
      if (userData?.teacher_name) {
        setTeacherName(userData.teacher_name)
      }
    }
  }, [userData]);

const getMatricData = async (udise_id) => {
    try { 
      let postData = {udise_id};
      const response = await axiosConn('post', `get-matrix-data`, postData);
      if (response.data.status === 'success') {
        setMatrixCount(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }
  

  

  const getCount = async () => {
    try {
      let postData = {};
      const response = await axiosConn('post', `dashboard-count`, postData,{},dispatch);
      if (response.data.status === 'success') {
        setCountData(response?.data?.data);
        updateLineChartData(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const data = {
    labels: [translate('Action'), translate('Awareness'), translate('Both')],
    datasets: [
      {
        data: [countData?.actionCount, countData?.awarenessCount, countData?.bothEventCount],
        backgroundColor: ['#28a745', '#ff9800', '#003366']
      }
    ]
  };

  const updateLineChartData = (data) => {
    const labels = [
      translate("January"), translate("February"), translate("March"), translate("April"), translate("May"), translate("June"),
      translate("July"), translate("August"), translate("September"), translate("October"), translate("November"), translate("December")
    ];
    const digitalData = data?.digitalCount || [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const physicalData = data?.physicalCount || [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    if (digitalData.length !== labels.length) {
      console.warn("Digital data length does not match labels length. Adjusting the data array.");
      while (digitalData.length < labels.length) digitalData.push(0);
      digitalData.length = labels.length;
    }

    if (physicalData.length !== labels.length) {
      console.warn("Physical data length does not match labels length. Adjusting the data array.");
      while (physicalData.length < labels.length) physicalData.push(0);
      physicalData.length = labels.length;
    }

    setLineChartData({
      labels,
      datasets: [
        {
          label: translate('Digital'),
          data: digitalData,
          fill: false,
          borderColor: 'rgba(75,192,192,1)'
        },
        {
          label: translate('Physical'),
          data: physicalData,
          fill: false,
          borderColor: '#742774'
        }
      ]
    });
  };

  const handleSidebar = () => {
    setOpenSidebar(!openSidebar);
  }
  return (
    <>
      <section className="scholdashbrdSec">
        <div className="desktopView" style={{ marginTop: 70, textAlign: "end" }}>
          <Link className="button green bars" onClick={handleSidebar}><FaBarsStaggered size={20} /></Link>
        </div>
        <div className={`sidebar ${openSidebar ? "open" : "hideen"}`}>
        <FacultySideBar langSelected={langSelected} index={0} role={role} />
        </div>
        <div className="schlDashbrdRgt">
          <div class="row">
            <div class="col-md-12">
              <div class="card-user pageContainer">
              <div className="d-flex justify-content-between align-items-center card-header">
                <div class="pgHederSpceArnd">
                  <h5 class="card-title">{schoolName} </h5>
                  
                  <p>{userData.state},{" "}{userData.district} ({udise_id})</p>
                  </div>
                </div>
                {role && role === 3 ? <><div>{teacher_name ? 'Welcome ' + teacher_name + ' [Faculty]' : '[Faculty]'}</div></>: ""}
                
              </div>
            </div>
          </div>
          <Row className="bodybox">
            <Col lg="3" md="6" sm="6" className="boxOne _1">
              <Link to="/faculty/eventlist">
                <Card className="card-stats">

                  <CardBody>
                    <Row>
                      <Col md="3" xs="3">
                        <div className="icon-big text-center icon-warning">
                          <MdEventNote />
                        </div>
                      </Col>
                      <Col md="9" xs="9">
                        <div className="numbers">
                          <p className="card-category">{translate("Overall_Events_Count")}</p>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>


                  <CardFooter>
                    <CardTitle tag="h3" className="text-center">
                    {matrixCount?.number_events || 0 }
                    </CardTitle>
                  </CardFooter>
                </Card>
              </Link>
            </Col>
            <Col lg="3" md="6" sm="6" className="boxOne _2">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <MdOutlineEnergySavingsLeaf />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category">{translate("Number of Saplings Planted")}</p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                  {matrixCount?.saplings_planted || 0 }
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6" className="boxOne _3">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <FaHandHoldingWater />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category">{translate("Amount of Harvest Produced")}</p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                  {matrixCount?.Amount_of_organic_produce || 0 }
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6" className="boxOne _4">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <TbVaccineBottleOff />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category">{translate("Amount of waste Collected")} </p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                  {matrixCount?.organic_waste_generated || 0 }
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>

            <Col lg="3" md="6" sm="6" className="boxOne _5">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <IoFastFood />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category"> {translate("Number of Leaks Detected")}</p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                  {matrixCount?.leaks_detected || 0 }
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>

            <Col lg="3" md="6" sm="6" className="boxOne _6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <FaBox />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category"> {translate("Amount of Plastic Waste Collected")}</p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                  {matrixCount?.single_use_plastic_bottle_collected || 0 }
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>

            <Col lg="3" md="6" sm="6" className="boxOne _7">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <GrRestroomWomen />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category">{translate("Energy_Saved_(Total_Energy_Saved_Conserved_(in_Watts)")}</p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                  {matrixCount?.electricity_units_consumed || 0 }
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>

            <Col lg="3" md="6" sm="6" className="boxOne _8">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="3" xs="3">
                      <div className="icon-big text-center icon-warning">
                        <FaBoxesPacking />
                      </div>
                    </Col>
                    <Col md="9" xs="9">
                      <div className="numbers">
                        <p className="card-category">{translate("amount of e-waste collected")}</p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <CardTitle tag="h3" className="text-center">
                  {matrixCount?.Amount_of_ewaste_collected || 0 }
                  </CardTitle>
                </CardFooter>
              </Card>
            </Col>
          </Row>
          <div className="dashbordChrtDivBtm">
            <Row>
              <Col md="4">
                <Card className="eventTypeChrt">
                  <CardHeader>
                    <CardTitle tag="h5">{translate("Event_Type")}</CardTitle>
                    <p className="card-category">{translate("Last_Event_Performance")}</p>
                  </CardHeader>
                  <CardBody style={{ height: "292px" }}>
                    <Pie
                      data={data}
                    // options={options}
                    />
                  </CardBody>
                  <CardFooter>
                    <div className="legend">
                      <FaCircle className="actioncolor" /> {translate("Action")}{" "}
                      <FaCircle className="awrcolor" /> {translate("Awareness")}{" "}
                      <FaCircle className="bothcolor" /> {translate("Both")} {" "}
                    </div>
                  </CardFooter>
                </Card>
              </Col>
              <Col md="8">
                <Card className="card-chart">
                  <CardHeader>
                    <CardTitle tag="h5">{translate("Mode_of_Implementation")}</CardTitle>
                    <p className="card-category">{translate("Line_Chart_with_Points")}</p>
                  </CardHeader>
                  <CardBody>
                    <Line
                      data={lineChartData}
                      options={{
                        responsive: true,
                        scales: {
                          x: {
                            display: true,
                            title: {
                              display: true,
                              text: translate('Month')
                            }
                          },
                          y: {
                            display: true,
                            title: {
                              display: true,
                              text: translate('Count')
                            }
                          }
                        }
                      }}
                      width={400}
                      height={100}
                    />
                  </CardBody>
                  <CardFooter>
                    <div className="chart-legend">
                      <FaCircle className="digitlalcolor" /> {translate("Digital")} {" "}
                      <FaCircle className="phyclcolor" /> {translate("Physical")}
                    </div>
                    <hr />
                    <div className="card-stats">
                      <i className="fa fa-check" /> {translate("Data_Information_Certified")}
                    </div>
                  </CardFooter>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </section>
    </>
  );
}

export default AdminDashboard;
